import __decorate from "../../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";
//#region src/components/default-not-found/DefaultNotFound.ts
var DefaultNotFound = class DefaultNotFound extends LitElement {
	static {
		this.styles = [css`
      :host {
        padding-top: 3em;
        display: block;
        text-align: center;

        background: var(--pd-default-error-light-col);
        border-radius: 15px;
        justify-self: center;
        padding: 2em;
        margin-top: 5em;

        border: 2px solid var(--pd-default-error-col);
      }
    `];
	}
	render() {
		return html`<h3>Keine passende Seite gefunden</h3>
      <p>Zu der URL konnte keine passende Seite gefunden werden</p>
      <a href="/">Zurück zur Startseite</a>`;
	}
};
DefaultNotFound = __decorate([customElement("default-not-found")], DefaultNotFound);
//#endregion
export { DefaultNotFound };
